.notesContainer {
    display: flex;
    column-gap: 20px;
}

.noteConfig {
    padding: 20px;
    border: 3px solid #FFF;
}